import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'binary-to-text',
  name: 'Binary to Text',
  category: 'utilities',
  description: 'Convert binary data (Base64) to text string with configurable encoding',
  icon: 'FileText',
  color: 'blue',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
